import { Component, OnInit } from '@angular/core';
import { PlatformService } from 'services/platform.service';

const SESSION_KEY = 'hatfield_competition_seen';

@Component({
	selector: 'ras-hatfield-competition-banner',
	templateUrl: './hatfield-competition-banner.component.html',
	styleUrls: ['./hatfield-competition-banner.component.sass']
})
export class HatfieldCompetitionBannerComponent implements OnInit {

	// Hardcoded, not pulled from live data - update manually as the competition progresses.
	activeCustomers = 21;
	goalCustomers = 250;

	visible = false;

	constructor(private platform: PlatformService) {}

	ngOnInit(): void {
		if (this.platform.isBrowser) {
			try {
				if (!sessionStorage.getItem(SESSION_KEY)) {
					this.visible = true;
				}
			} catch {
				this.visible = true;
			}
		}
	}

	dismiss(): void {
		this.visible = false;
		if (this.platform.isBrowser) {
			try {
				sessionStorage.setItem(SESSION_KEY, '1');
			} catch {}
		}
	}

	get progressPercent(): number {
		return Math.min(100, Math.round((this.activeCustomers / this.goalCustomers) * 100));
	}

}
